/**
 * Dashboard API service file
 *
 * @package    src/services
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly/api/dashboard/
 */
import axios from 'axios'
import { ApiConstant, MessageConstant, CodeConstant } from '../constants'
import queryString from 'query-string';
import { getAvailabilityName } from '../constants/AvailabilityType';

/**
 * Get user's profile data
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function getPersonalData() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PERSONAL_DATA, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PERSONAL_DATA)
  }
}

/**
 * get all user information in new profile page
 */
export function getAllUserProfileData(userId, adminView) {
  var token = localStorage.getItem(adminView ? 'adminToken' : 'token')
  var header, params

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    params = { 'userId': userId }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ALL_USER_PROFILE_DATA, { headers: header, params })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ALL_USER_PROFILE_DATA)
  }
}

/**
 * get projects' screenshots in profile page
 */

export function getUserProjectScreenshots(userId, adminView) {
  var token = localStorage.getItem(adminView ? 'adminToken' : 'token')
  var header, params

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    params = { 'userId': userId }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_PROJECT_SCREENSHOTS, { headers: header, params })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_PROJECT_SCREENSHOTS)
  }
}

/**
 * get only countries for now, no need of fetching the whole skill list or certification list
 */
export function getAllBaseProfileData(userId, adminView) {
  var token = localStorage.getItem(adminView ? 'adminToken' : 'token')
  var header, params

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    params = { 'userId': userId }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ALL_BASE_PROFILE_DATA, { headers: header, params })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ALL_BASE_PROFILE_DATA)
  }
}

/**
 * Search for skills
 * 
 */
export function getSkillCertList(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.GET_SKILLS_CERTIFICATION, data, { headers: header });
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.GET_SKILLS_CERTIFICATION);
  }
}

export function getProductDesignInfo() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PRODUCT_DESIGN_INFO, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PRODUCT_DESIGN_INFO)
  }
}

/**
 * get publication information in new profile page
 */
export function getSystemDesignInfo() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_SYSTEM_DESIGN_INFO, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_SYSTEM_DESIGN_INFO)
  }
}

/**
 * update user's profile data
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function updateProfileInfo(data, fileData) {
  var token = localStorage.getItem('token')
  var header
  const formData = new FormData()
  formData.append('file', fileData)
  formData.append('data', JSON.stringify(data))

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROFILE_INFO, formData, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROFILE_INFO, formData)
  }
}

/**
 * update user's profile data
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function updateProfileData(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROFILE_DATA, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROFILE_DATA, data)
  }
}

/**
 * save user information for new profile page
 */
export function savePersonalInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PERSONAL_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PERSONAL_INFO, data)
  }
}

/**
 * Update developer availability
 */
export function saveDeveloperAvailability(data) {

  const availabilityData = {
    availability_status: data.answer,
    availability_type: getAvailabilityName(data.availabilityStatusId),
    notice_period: data.startsInWeeks,
    action_from: 'developer'
  }

  var token = localStorage.getItem('token');
  var header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_DEVELOPER_AVAILABILITY, availabilityData, { headers: header })
      .catch((error) => {
        console.log("Error in saving developer availability", error);
      });
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_DEVELOPER_AVAILABILITY, availabilityData)
      .catch((error) => {
        console.log("Error in saving developer availability", error);
      });
  }
}

/**
 * Save developer cloud certificate
 */
export function saveDeveloperCloudCertificatePartial(data) {
  var token = localStorage.getItem('token');
  var header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_DEVELOPER_CLOUD_CERTIFICATES_PARTIAL, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_DEVELOPER_AVAILABILITY, availabilityData)
  }
}

/**
 * Save developer general certificate
 */
export function saveDeveloperGeneralCertificates(data) {
  var token = localStorage.getItem('token');
  var header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, {
      addedItems: data,
      deletedItems: [],
      updatedItems: []
    }, { headers: header });
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, {
      addedItems: data,
      deletedItems: [],
      updatedItems: []
    });
  }
}


/** Save new availability answer */
export const saveNewAvailabilityAns = (answer) => {
  const token = localStorage.getItem('token')
  let header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_NEW_AVAILABILITY_ANSWER, { answer }, { headers: header })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}


/**
 * Get developer availability statuses
 */
export function getDeveloperAvailabilityStatuses() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_DEVELOPER_AVAILABILITY_STATUSES, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_DEVELOPER_AVAILABILITY_STATUSES)
  }
}

/**
 * developer VET completed
 */
export function developerSignupCompleted() {
  var token = localStorage.getItem('token');
  const jobCode = localStorage.getItem("jobCode");
  const isRecommendedJobFlow = !!jobCode && jobCode !== 'null' && jobCode !== 'undefined';
  var header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };

    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, { action: 'SIGNUP_COMPLETED', isRecommendedJobFlow }, { headers: header });
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, { action: 'SIGNUP_COMPLETED', isRecommendedJobFlow });
  }
}

/**
 * 
 * @param {*} fileData 
 */
export function getResumeInfo() {
  const token = localStorage.getItem('token');
  let header;
  const data = {
    action: 'GET_RESUME_INFO'
  }

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING)
  }
}

/**
 * save resume file
 */
export function saveResume(fileData, onboarding = false, replaceData = false) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('resume', fileData)
  formData.append('onboarding', onboarding)
  formData.append('replaceData', replaceData);
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_RESUME, formData, { headers: header })
}

/**
 * save avatar file
 */
export function saveAvatar(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('avatar', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_AVATAR, formData, { headers: header })
}

/*
 * Save system design answer file
 */
export function saveSystemDesignAnswerFile(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('answer_file', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_SYSTEM_DESIGN_INFO, formData, { headers: header })
}

/*
 * Save product design answer file
 */
export function saveProductDesignAnswerFile(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('answer_file', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PRODUCT_DESIGN_INFO, formData, { headers: header })
}

/*
 * Upload machine learning submission to GCS
 */
export function uploadDesignOptionFile(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('answer_file', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.UPLOAD_DESIGN_CHALLENGE_OPTION_SUBMISSION, formData, { headers: header })
}

/**
 * save experience information for new profile page
 */
export function saveExperienceInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EXPERIENCE_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EXPERIENCE_INFO, data)
  }
}

/**
 * save project information for new profile page
 */
export function saveProjectInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PROJECT_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PROJECT_INFO, data)
  }
}

/**
 * upload project screenshots 
 */
export function uploadProjectScreenshot(image, project_id) {
  const header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  };
  const fmData = new FormData();
  fmData.append('image', image);
  fmData.append('project_id', project_id);

  return axios.post(ApiConstant.BASE_URL + ApiConstant.UPLOAD_SCREENSHOT, fmData, { headers: header });
}

/**
 * save education information for new profile page
 */
export function saveEducationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_INFO, data)
  }
}

/**
 * save certification & award information for new profile page
 */
export function saveCertificationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATION_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATION_INFO, data)
  }
}

/**
 * save tech skill information for new profile page
 */
export function saveTechSkillsInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_TECHSKILLS_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_TECHSKILLS_INFO, data)
  }
}

/**
 * update developer tech skills 
 */
export function updateDeveloperSkills(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_DEVELOPER_SKILLS, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_DEVELOPER_SKILLS, data)
  }
}

/**
 * save publication information for new profile page
 */
export function savePublicationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATION_INFO, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATION_INFO, data)
  }
}

/**
 * save publication information for new profile page
 */
export function savePublicationInfoV2(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATION_INFO_V2, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATION_INFO_V2, data)
  }
}

export function saveLinks(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_LINKS, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_LINKS, data)
  }
}

/**
 * update experience information for new profile page
 */
export function updateExperienceInfo(data, cId) {
  var token = localStorage.getItem('token')
  var header
  if (token) {
    header = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_EXPERIENCE_INFO + '/' + cId, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_EXPERIENCE_INFO + '/' + cId, data)
  }
}

/**
 * update project information for new profile page
 */
export function updateProjectInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROJECT_INFO + '/' + data.cId, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROJECT_INFO + '/' + data.cId, data)
  }
}

/**
 * save projects changes
 * @param object data -> { addedItems: [ obj , ... ], deletedItems: [ obj , ... ], updatedItems: [ obj , ... ] }
 */
export function saveProjectsChanges(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.SAVE_PROJECTS_CHANGES, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.SAVE_PROJECTS_CHANGES, data)
  }
}

/**
 * save education changes
 * @param object data -> { addedItems: [ obj , ... ], deletedItems: [ obj , ... ], updatedItems: [ obj , ... ] }
 */
export function saveEducationChanges(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_CHANGES, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_CHANGES, data)
  }
}

/**
 * save education changes
 * @param object data -> { addedItems: [ obj , ... ], deletedItems: [ obj , ... ], updatedItems: [ obj , ... ] }
 */
export function savePublicationsChanges(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATIONS_CHANGES, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATIONS_CHANGES, data)
  }
}

/**
 * save education changes
 * @param object data -> { addedItems: [ obj , ... ], deletedItems: [ obj , ... ], updatedItems: [ obj , ... ] }
 */
export function saveCertificationsChanges(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, data)
  }
}

/**
 * update education information for new profile page
 */
export function updateEducationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_EDUCATION_INFO + '/' + data.cId, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_EDUCATION_INFO + '/' + data.cId, data)
  }
}

/**
 * update certification & award information for new profile page
 */
export function updateCertificationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_CERTIFICATION_INFO + '/' + data.cId, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_CERTIFICATION_INFO + '/' + data.cId, data)
  }
}

/**
 * update tech skill information for new profile page
 */
export function updateTechSkillsInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_TECHSKILLS_INFO, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_TECHSKILLS_INFO, data)
  }
}

/**
 * update publication information for new profile page
 */
export function updatePublicationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_PUBLICATION_INFO + '/' + data.cId, data, { headers: header })
  } else {
    return axios.put(ApiConstant.BASE_URL + ApiConstant.UPDATE_PUBLICATION_INFO + '/' + data.cId, data)
  }
}

/**
 * delete avator file
 */
export function deleteAvatar() {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }
  return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_AVATAR, { headers: header })
}

/**
 * delete user experience information for new profile page
 */
export function deleteExperienceInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_EXPERIENCE_INFO + '/' + data.cId, { headers: header })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_EXPERIENCE_INFO + '/' + data.cId)
  }
}

/**
 * delete user project information for new profile page
 */
export function deleteProjectInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_PROJECT_INFO + '/' + data.cId, { headers: header })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_PROJECT_INFO + '/' + data.cId)
  }
}

/**
 * delete user education information for new profile page
 */
export function deleteEducationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_EDUCATION_INFO + '/' + data.cId, { headers: header })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_EDUCATION_INFO + '/' + data.cId)
  }
}

/**
 * delete user certification & award information for new profile page
 */
export function deleteCertificationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_CERTIFICATION_INFO + '/' + data.cId, { headers: header })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_CERTIFICATION_INFO + '/' + data.cId)
  }
}

/**
 * delete user tech skill information for new profile page
 */
export function deleteTechSkillsInfo(data) {
  var token = localStorage.getItem('token')
  var header
  const deleteObj = {
    userSkills: data
  };
  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_TECHSKILLS_INFO, { headers: header, data: deleteObj })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_TECHSKILLS_INFO, { data: deleteObj })
  }
}

/**
 * delete publication information for new profile page
 */
export function deletePublicationInfo(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_PUBLICATION_INFO + '/' + data.cId, { headers: header })
  } else {
    return axios.delete(ApiConstant.BASE_URL + ApiConstant.DELETE_PUBLICATION_INFO + '/' + data.cId)
  }
}

/**
 * update user's password
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function updatePassword(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.CHANGE_PASSWORD, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.CHANGE_PASSWORD, data)
  }
}

export function updateEmail(data) {
  var token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.CHANGE_EMAIL, data, { headers: header })
  }
  return Promise.resolve({ data: { code: CodeConstant.UNAUTHORIZED, message: MessageConstant.UNAUTHORIZED } });
}

export function addNewAccountSettings(updateType, data) {
  const token = localStorage.getItem('token');
  const body = {
    updateType, data
  }
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ADD_NEW_ACCOUNT_SETTING, body, { headers: header })
  }
  return Promise.resolve({ data: { code: CodeConstant.UNAUTHORIZED, message: MessageConstant.UNAUTHORIZED } });
}

/**
 * Get user's account info
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function getAccountInfo() {
  var token = localStorage.getItem('token')
  var header
  const currentQuery = queryString.parse(window.location.search);
  const newsession = currentQuery.s && currentQuery.token;
  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ACCOUNT_INFO + (newsession ? '?newsession=1' : ''), { headers: header });
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_ACCOUNT_INFO + (newsession ? '?newsession=1' : ''));
  }
}

/**
 * Get user's account info
 *
 * @author  YingTuring <ying@turing.com>
 * @param
 * @return  ret
 */
export function getTestResult() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_TEST_RESULT, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_TEST_RESULT)
  }
}

/**
 * Save selected language
 *
 * @author  YingTuring <ying@turing.com>
 * @param   string   languageName   selected lanuage name
 * @return  ret
 */
export function saveSelectedLanguage(languageName, comeFrom) {
  var token = localStorage.getItem('token')

  var header = {
    'Content-Type': 'application/json',
    'Authorization': token
  }

  var postData = {
    from: comeFrom,
    testName: languageName
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_SELECTED_LANGUAGE, postData, { headers: header })
}

/**
 * Delete Account
 *
 * @author  YingTuring <ying@turing.com>
 * @return  ret
 */
export function deleteAccount(password) {
  var token = localStorage.getItem('token')

  var header = {
    'Content-Type': 'application/json',
    'Authorization': token
  }

  return axios.delete(ApiConstant.BASE_URL + ApiConstant.Delete_Account, { headers: header, data: { password } });
}

/**
 * Get challenge type
 *
 * @author  YingTuring <ying@turing.com>
 * @return  ret
 */
export function getChallengeType() {
  var token = localStorage.getItem('token')

  var header = {
    'Content-Type': 'application/json',
    'Authorization': token
  }

  return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CHALLENGE_TYPE, { headers: header })
}

/**
 * Get host link
 *
 * @author  YingTuring <ying@turing.com>
 * @return  ret
 */
export function getHostLink(data, fileData) {
  var token = localStorage.getItem('token')
  var header = {}
  const formData = new FormData()
  formData.append('file', fileData)
  formData.append('data', JSON.stringify(data))

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
  }
  return axios.post(ApiConstant.CHALLENGE_BASE_URL + ApiConstant.GET_HOST_LINK, formData, { headers: header })
}

/**
 * Get Autohost Build Status
 *
 * @author  FrederickTuring <frederick.a@turing.com>
 * @return  ret
 */
export function getAutoHostBuildStatus(hostLink) {
  var token = localStorage.getItem('token')

  const header = {
    'Content-Type': 'application/json',
    'Authorization': token
  }
  return axios.get(`${ApiConstant.CHALLENGE_BASE_URL}${ApiConstant.GET_AUTOHOST_BUILD_STATUS}?host_link=${hostLink}`, { headers: header })
}

/**
 * Get Challenge infos
 *
 * @author  YingTuring <ying@turing.com>
 * @return  ret
 */
export function getChallengeInfo(typeName) {
  var token = localStorage.getItem('token')

  var header = {
    'Content-Type': 'application/json',
    'Authorization': token
  }

  var getData = {
    typeName: typeName
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.GET_CHALLENGE_Info, getData, { headers: header })
}

/**
 * Send email to turing manager
 *
 * @author  WangTuring <wangwang@turing.com>
 * @param
 * @return  ret
 */
export function sendEmailToManager(challengeType) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const data = {
    challengeType: challengeType
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.SEND_EMAIL_TO_MANAGER, data, { headers: header })
}

/**
 * Save show description track value
 *
 * @author  YingTuring <ying@turing.com>
 * @param   challengeName
 * @return  ret
 */
export function saveDescriptionTrackValue(data) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_SHOW_DESCRIPTION_TRACK, data, { headers: header })
}

/**
 * upload Cover Image
 */
export function saveCoverImage(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('cover_image', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.UPLOAD_COVER_IMAGE, formData, { headers: header })
}

/**
 * upload Icon Image
 */
export function saveIconImage(fileData) {
  let header = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token') || ''
  }

  const formData = new FormData()
  formData.append('icon_image', fileData)
  return axios.post(ApiConstant.BASE_URL + ApiConstant.UPLOAD_ICON_IMAGE, formData, { headers: header })
}

/**
 * Create service-account
 *
 * @author  Salman <salman.s@turing.com>
 * @param   
 * @return  object              
 */
export function createServiceAccount(data) {
  var token = localStorage.getItem('adminToken');
  var header = {
    'Content-Type': 'application/json',
    'authorization': token
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.CREATE_SERVICE_ACCOUNT, data, { headers: header })
}

/**
 * Delete service-account
 *
 * @author  Salman <salman.s@turing.com>
 * @param   
 * @return  object              
 */
export function deleteServiceAccount(data) {
  var token = localStorage.getItem('adminToken');
  var header = {
    'Content-Type': 'application/json',
    'authorization': token
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.DELETE_SERVICE_ACCOUNT, data, { headers: header })
}

/**
 * Get service-accounts
 *
 * @author  Salman <salman.s@turing.com>
 * @param   
 * @return  object              
 */
export function getServiceAccounts() {
  var token = localStorage.getItem('adminToken');
  var header = {
    'Content-Type': 'application/json',
    'authorization': token
  }

  return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_SERVICE_ACCOUNTS, { headers: header })
}

/**
 * Get signup funnel english experience info
 *
 * @author  Salman <salman.s@turing.com>
 * @param   
 * @return  object              
 */
export function getUserSignupFunnelInfo() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_SIGNUP_FUNNEL_INFO, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_SIGNUP_FUNNEL_INFO)
  }
}

export function getCurrencyRateList() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CURRENCY_RATE_LIST, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CURRENCY_RATE_LIST)
  }
}

export function getCloudCertificateTypes() {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CLOUD_CERTIFICATION_LIST, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CLOUD_CERTIFICATION_LIST)
  }
}

export function getUserCloudCertificates() {
  var token = localStorage.getItem('token');
  var header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_CLOUD_CERTIFICATES, { headers: header })
  } else {
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_CLOUD_CERTIFICATES)
  }
};

export function getUserAvailabilityV2() {
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_AVAILABILITY_V2, { headers: header })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

export function getUserSidebarData() {
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_USER_SIDEBAR_DATA, { headers: header })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}


/**
 * Get parsed resume data.
 *
 * @author  Wassim <wassim.b@turing.com>
 * @return  object
 */
export function getParsedResumeData() {
  const token = localStorage.getItem('token');

  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PARSED_RESUME_DATA, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
};

/**
 * GET basic info page data
 */

export function getBasicInfo() {
  const token = localStorage.getItem('token');
  const body = {
    action: 'GET_PAGE_ONE_INFO'
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, body, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * GET user github url/linkedin url
 */

export function getSocialLinks() {
  const token = localStorage.getItem('token');
  const body = {
    action: 'GET_SOCIAL_LINKS'
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, body, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get User Salary type
 */
export function getUserSalaryType() {
  const token = localStorage.getItem('token');
  const body = {
    action: 'GET_USER_SALARY_TYPE'
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(`${ApiConstant.BASE_URL}common-user/`, body, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get User Role Type
 */
export function getJobRoleType() {
  const token = localStorage.getItem('token');
  const body = {
    action: 'GET_JOB_ROLE_TYPE'
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(`${ApiConstant.BASE_URL}common/`, body, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/** 
 * Post Basic Info Data
 */
export function updateBasicInfo(data) {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * 
 */
export function getAllCountries() {
  const token = localStorage.getItem('token');
  const data = {
    action: 'GET_ALL_COUNTRIES'
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Updates last visited step for onboarding page
 */
export function updateLastVisitedStep(lastVisitedStep) {
  const token = localStorage.getItem('token');
  const data = {
    lastVisitedStep
  };
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.LAST_VISITED_STEP, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Gets last visited step for onboarding page
 */
export function getLastVisitedStep() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.LAST_VISITED_STEP, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Fetch Education data
 */
export function getEducationInfo() {
  const token = localStorage.getItem('token');
  const data = {
    action: 'GET_USER_EDUCATION'
  }
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get User Publications
 */
export function getUserPublications() {
  const token = localStorage.getItem('token');
  const data = {
    action: 'GET_USER_PUBLICATIONS'
  }
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get User Links
 */
export function getUserLinks() {
  const token = localStorage.getItem('token');
  const data = {
    action: 'GET_USER_LINKS'
  }
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Send email Invite
 */
export function sendEmailInvite(emails) {
  const token = localStorage.getItem('token');
  const data = {
    emails
  }
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SEND_EMAIL_INVITE, data, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get referral code
 */
export function getRefferalCode() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_REFERRAL_CODE, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get turing resume link
 */
export function getTuringResumeLink() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_TURING_RESUME_LINK, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get developer skill info
 */

export function getDeveloperSkillInfo() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_DEVELOPER_SKILL_INFO, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Update developer profile last update date
 */
function updateProfileUpdateDate() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.UPDATE_PROFILE_UPDATE_DATE, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get developer profile last update date
 */
export function getDeveloperProfileLastUpdateDate() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_PROFILE_UPDATE_DATE, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get developer compensation
 */
export function getUserCompensation() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_COMPENSATION, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/**
 * Get developer recommended tests
 */
export function getRecommendedTests() {
  const token = localStorage.getItem('token');
  if (token) {
    const header = {
      'Content-Type': 'application/json',
      Authorization: token
    }
    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_RECOMMENDED_TESTS, { headers: header });
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}


/**
 * get client information on Onboarding page
 */
export function getClientInformationData() {
  var token = localStorage.getItem('token')
  var headers;

  if (token) {
    headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CLIENT_INFORMATION, { headers })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}
/**
 * get client information on Onboarding page
 */
export function getClientInformationDataByIp(ip) {
  return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CLIENT_INFORMATION_BY_IP + `?ip=${ip}`)
}


/** Get developer referral source for onboarding page */
export function getDeveloperReferralSource() {
  var token = localStorage.getItem('token')
  var headers;

  if (token) {
    headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, { action: 'GET_DEVELOPER_REFERRAL_SOURCE' }, { headers })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

/** Update developer referral source for onboarding page */
export function updateDeveloperReferralSource(data) {
  var token = localStorage.getItem('token')
  var headers;

  if (token) {
    headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.ONBOARDING, { action: 'UPDATE_DEVELOPER_REFERRAL_SOURCE', data }, { headers })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}


/** Get LinkedIn data using profile url */
export function getLinkedInData(data) {
  var token = localStorage.getItem('token')
  var headers;

  if (token) {
    headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    return axios.post(ApiConstant.BASE_URL + ApiConstant.SYNC_LINKEDIN_DATA, data, { headers })
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}

export function markVetsmithStepComplete(flow_id, flow_step_id) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.MARK_VETSMITH_STEP_COMPLETE_FOR_DEV, {
    flow_id,
    flow_step_id
  })
}


/**
* API service for fetching and storing cosine similarity for job-dev pair
*/
export function resumeJobPostProcess(data = null) {
  var token = localStorage.getItem('token')

  if (token) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token,
      mode: 'no-cors',
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.RESUME_JOB_POST_PROCESS, {
          /**No data to send as of now, will update later if needed */
        }, { headers });    
  } else {
    return Promise.reject(new Error('Expected token'));
  }
}
